import React from "react";
import { Container, Typography, Box, AppBar, Toolbar } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Box>
      {/* Header */}
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" fontWeight={600}>
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Typography variant="h4" gutterBottom fontWeight={600}>
          Privacy Policy
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Last updated: 31st December, 2025
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Effective: Upon publication
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography paragraph>
            Bangladesh General Insurance Company PLC (“BGIC”, “we”, “our”, “us”)
            respects your privacy. This Privacy Policy explains how we collect,
            use, disclose, and safeguard your personal information when you visit{" "}
            <strong>https://www.bgicdigital.com/</strong> and use our digital
            services.
          </Typography>

          <Typography paragraph>
            <strong>1. Information We Collect</strong>
            <ul>
              <li>
                <strong>Personal Data:</strong> Name, phone number, email
                address, address, date of birth, National ID/PASSPORT, policy
                details, etc.
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, device information,
                browser type, usage logs.
              </li>
              <li>
                <strong>Payment Information:</strong> Payment verification
                details through SSLCommerz (card data is not stored by BGIC).
              </li>
            </ul>
            All data is collected with your consent when you submit forms or
            interact with the digital platform.
          </Typography>

          <Typography paragraph>
            <strong>2. Use of Your Information</strong>
            <ul>
              <li>Process insurance applications, premiums, claims, and refund or cancellation of policy</li>
              <li>Communicate regarding your policies and requests</li>
              <li>Provide customer support</li>
              <li>Improve our services and digital experience</li>
              <li>Prevent fraud and ensure regulatory compliance</li>
            </ul>
          </Typography>

          <Typography paragraph>
            <strong>3. Payment Security</strong><br />
            All payment transactions are securely handled through SSLCommerz, a
            trusted and PCI-DSS compliant gateway. BGIC does not store sensitive
            payment card details on its servers.
          </Typography>

          <Typography paragraph>
            <strong>4. Data Sharing</strong>
            <ul>
              <li>Service providers supporting our operations</li>
              <li>Regulatory authorities as required by law</li>
              <li>Law enforcement for legal compliance</li>
            </ul>
            We do not sell or rent your personal information.
          </Typography>

          <Typography paragraph>
            <strong>5. Cookies & Tracking</strong><br />
            We use cookies and similar technologies to enhance user experience,
            analyze usage, and tailor offerings. You may disable cookies in your
            browser, though some features may not function fully.
          </Typography>

          <Typography paragraph>
            <strong>6. Data Security</strong><br />
            We apply reasonable technical and organizational safeguards to
            protect your data. However, no internet transmission is 100% secure.
          </Typography>

          <Typography paragraph>
            <strong>7. Your Rights</strong><br />
            You may request access, correction, or deletion of your personal
            information by contacting us.
          </Typography>

          <Typography paragraph>
            <strong>8. Contact</strong><br />
            📧 Email: info@bgicinsure.com / bgicinsurance@gmail.com<br />
            📍 Address: 42, Dilkusha Commercial Area, Dhaka-1000, Bangladesh
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
